<template>
  <div class="do-button-and-date">
    <button class="do-bttn do-bttn__filter" v-if="isDatepickerOpen && selectedDate"
            @click="$emit('dateChanged', null)">
      Luk for fagønsker
    </button>
    <button class="do-bttn do-bttn__filter" @click="isDatepickerOpen = !isDatepickerOpen">
      <template v-if="!selectedDate">
        {{ isDatepickerOpen ? 'Slutdato for fagønsker' : 'Åbn for fagønsker' }}
      </template>
      <template v-if="selectedDate">
        Slutdato for fagønsker
        <div class="do-filters__divider"></div>
        <span class="do-badge">{{ selectedDateFormatted }}</span>
      </template>
    </button>
    <div class="do-button-and-date__datepicker" v-if="isDatepickerOpen">
      <DateSelector
        :isOpen="true"
        :isShowInput="false"
        :date="selectedDate ? selectedDate : new Date()"
        style="width: 210px;"
        @changed="setDate($event)"
        @close="isDatepickerOpen = false">
      </DateSelector>
    </div>
  </div>
</template>
<script>
import DateSelector from '../datepicker/DateSelector'
import moment from 'moment'

export default {
  components: {DateSelector},
  props: {
    selectedDate: {
      default: () => null
    }
  },
  data () {
    return {
      date: moment(),
      isDatepickerOpen: false
    }
  },
  computed: {
    selectedDateFormatted () {
      return moment(this.selectedDate).format('DD/MM-YY')
    }
  },
  methods: {
    setDate (date) {
      this.$emit('dateChanged', date)
    }
  }
}
</script>

<style scoped>
@import "../../assets/css/variables.css";

.do-button-and-date__datepicker {
  position: absolute;
}

.do-button-and-date .do-bttn__filter {
  border-style: solid;
}

.do-button-and-date .do-bttn__filter--danger {
  background: var(--danger);
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// DoButtonAndDate.vue?425b2395